import { tv, type VariantProps } from '@workspace/lib';

// Themeable/customizable classes only. Stable structure belongs in Newsletter.tsx.
export const newsletterVariants = tv({
  slots: {
    section: 'px-6 py-xl md:px-4xl md:py-4xl',
    wrapper: 'gap-lg md:gap-4xl',
    leftColumn: 'md:max-w-125',
    heading: 'font-bold mb-sm',
    description: 'text-secondary-500',
    rightColumn: 'md:w-135',
    inputGroup: 'gap-sm md:gap-xs',
    label: 'text-base font-semibold mb-xs text-secondary-400',
    input: 'h-11 py-xs px-button border rounded-sm bg-white focus:outline-none focus:ring-1 focus:ring-primary',
    inputText: 'font-body text-gray-900',
    errorWrapper: 'md:mt-xs',
    errorText: 'text-error',
    submitButton: 'h-11 md:w-45 px-md rounded-sm font-semibold',
    submitButtonText: 'text-white font-heading text-base font-semibold leading-5',
    successWrapper: 'gap-3xs md:gap-sm md:w-125.25 md:h-44.5',
    successHeading: 'text-lg tracking-tight',
    successDescription: 'text-secondary-600',
    successIcon: 'size-6 text-secondary-400',
  },
});

export type NewsletterVariants = VariantProps<typeof newsletterVariants>;

export interface NewsletterSuccessConfig {
  heading?: string;
  description: string;
  showIcon?: boolean;
  replaceFormOnly?: boolean;
  iconName?: string;
}

export const newsletterSuccessConfig: NewsletterSuccessConfig = {
  heading: 'You\u2019re subscribed to the Porta Newsletter!',
  description: 'Check your inbox for a confirmation email.',
  showIcon: false,
  replaceFormOnly: false,
  iconName: 'CircleCheck',
};
